import React from "react";
import { FluentProvider, teamsLightTheme } from "@fluentui/react-components";
import "./App.css";
import WelcomeContainer from "./Containers/WelcomeContainer";
import InitContainer from "./Containers/InitContainer";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { NotificationProvider } from "./Components/GenericComponent/NotificationSystem";

function App() {

  return (
    <>
    
      <FluentProvider theme={teamsLightTheme}>
        <NotificationProvider>
          <AuthenticatedTemplate>
            <InitContainer />
          </AuthenticatedTemplate> 
          <UnauthenticatedTemplate>
            <WelcomeContainer />
          </UnauthenticatedTemplate>
        </NotificationProvider>
      </FluentProvider>
    </>
  );
}

export default App;
